import { render } from "./RazzoForm.vue?vue&type=template&id=cdf5562c"
import script from "./RazzoForm.vue?vue&type=script&lang=js"
export * from "./RazzoForm.vue?vue&type=script&lang=js"

import "./RazzoForm.vue?vue&type=style&index=0&id=cdf5562c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__